import type { StorefrontConfig } from "../types/storefront";

const dailyHours = Array.from({ length: 7 }, (_, day) => ({ day, open: "08:00", close: "23:00" }));

export const mockStores: StorefrontConfig[] = [
  {
    storeSlug: "meyar",
    storeName: "Meyar Super Store",
    tagline: "Everyday essentials, carefully selected",
    primaryColor: "#0b6bcb",
    secondaryColor: "#f59e0b",
    accentColor: "#e11d48",
    themeId: "modern-retail",
    heroTitle: "Everything your home needs, delivered",
    heroSubtitle: "Shop groceries, personal care and household essentials from your nearest Meyar branch.",
    heroImage: "/catalog/grc.webp",
    phone: "021 111 639 271",
    whatsapp: "923001234567",
    email: "orders@meyar.example",
    address: "Main Boulevard, Lahore",
    about: "Meyar is a neighborhood super store focused on dependable products, fair prices and quick delivery.",
    businessHours: dailyHours,
    deliveryEnabled: true,
    pickupEnabled: true,
    deliveryCharge: 150,
    freeDeliveryThreshold: 3000,
    minimumOrderAmount: 500,
    storefrontEnabled: true
  },
  {
    storeSlug: "freshmart",
    storeName: "Fresh Mart",
    tagline: "Fresh choices for every table",
    primaryColor: "#24783b",
    secondaryColor: "#f3b61f",
    accentColor: "#d84a36",
    themeId: "fresh-market",
    heroTitle: "Market freshness, without the market rush",
    heroSubtitle: "Daily produce, dairy and pantry staples picked from the branch closest to you.",
    heroImage: "/catalog/frz.webp",
    phone: "051 111 373 740",
    whatsapp: "923111234567",
    email: "hello@freshmart.example",
    address: "F-7 Markaz, Islamabad",
    about: "Fresh Mart brings market-quality staples and produce to busy households across Islamabad.",
    businessHours: dailyHours,
    deliveryEnabled: true,
    pickupEnabled: true,
    deliveryCharge: 180,
    freeDeliveryThreshold: 2500,
    minimumOrderAmount: 400,
    storefrontEnabled: true
  },
  {
    storeSlug: "royalbakery",
    storeName: "Royal Bakery & Cafe",
    tagline: "Baked today, enjoyed today",
    primaryColor: "#9a3e26",
    secondaryColor: "#e2a54d",
    accentColor: "#39796b",
    themeId: "bakery-cafe",
    heroTitle: "Fresh bakes for everyday celebrations",
    heroSubtitle: "Order breads, pastries, cakes and cafe favorites for delivery or pickup.",
    heroImage: "/catalog/brk.webp",
    phone: "042 111 769 250",
    whatsapp: "923221234567",
    email: "orders@royalbakery.example",
    address: "Gulberg III, Lahore",
    about: "Royal Bakery has baked small-batch breads, cakes and cafe treats for local families since 1998.",
    businessHours: dailyHours,
    deliveryEnabled: true,
    pickupEnabled: true,
    deliveryCharge: 200,
    freeDeliveryThreshold: 3500,
    minimumOrderAmount: 600,
    storefrontEnabled: true
  },
  {
    storeSlug: "urbanstyle",
    storeName: "Urban Style",
    tagline: "Considered pieces for modern living",
    primaryColor: "#20242a",
    secondaryColor: "#c79a5a",
    accentColor: "#6e5f8d",
    themeId: "premium-minimal",
    heroTitle: "Modern essentials, quietly distinctive",
    heroSubtitle: "A refined edit of apparel, beauty and lifestyle pieces.",
    heroImage: "/catalog/cos.webp",
    phone: "021 111 872 260",
    whatsapp: "923331234567",
    email: "care@urbanstyle.example",
    address: "Clifton, Karachi",
    about: "Urban Style is a modern lifestyle store curating useful pieces with enduring design.",
    businessHours: dailyHours,
    deliveryEnabled: true,
    pickupEnabled: false,
    deliveryCharge: 250,
    freeDeliveryThreshold: 5000,
    minimumOrderAmount: 1000,
    storefrontEnabled: true
  }
];
